import React from "react";
import moment from "moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const getEntityInformation = (
  selectedEntity: any,
  selectedEntityType: string
) => {
  if (selectedEntityType === "bâtiment") {
    return (
      <>
        <div className="p-6 h-full">
          <img
            src="/images/batiments-3d.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />

          <h5>
            Nom bâtiment : <strong>{selectedEntity.nom_bâtiment}</strong>
          </h5>
          <h5>
            Date de construction bâtiment :{" "}
            <strong>{selectedEntity.date_construction}</strong>
          </h5>
          <h5>
            Date de création :{" "}
            <strong>
              {" "}
              {moment(selectedEntity.created_at).format("MMMM Do YYYY")}
            </strong>
          </h5>

          <div className="mt-5 overflow-x-auto shadow-md overflow-y-auto">
            <DataTable
              value={selectedEntity?.adresses}
              editMode="row"
              dataKey="id"
              tableStyle={{ minWidth: "40rem" }}
            >
              <Column
                field="nom_adresse"
                header="nom adresse"
                style={{ width: "20%" }}
              />
              <Column field="rue" header="Rue" style={{ width: "10%" }} />
              <Column field="rue2" header="Rue 2" style={{ width: "10%" }} />
              <Column
                field="code_postal"
                header="Code postale"
                style={{ width: "10%" }}
              />
              <Column field="ville" header="ville " style={{ width: "10%" }} />
              <Column field="pays" header="Pays" style={{ width: "10%" }} />
            </DataTable>
          </div>
        </div>
      </>
    );
  }
  if (selectedEntityType === "niveau") {
    return (
      <>
        <div className="p-6">
          <img
            src="/images/couches.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />

          <h5>
            Nom Niveau : <strong>{selectedEntity.nom_niveau}</strong>
          </h5>
          <h5>
            Numéro d'ordre : <strong>{selectedEntity.numero_ordre}</strong>
          </h5>
          <h5>
            Numéro : <strong>{selectedEntity.numero}</strong>
          </h5>
          <h5>
            Date de création :{" "}
            <strong>
              {" "}
              {moment(selectedEntity.created_at).format("MMMM Do YYYY")}
            </strong>
          </h5>
        </div>
      </>
    );
  }
  if (selectedEntityType === "espace") {
    return (
      <>
        <div className="p-6">
          <img
            src="/images/espace.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />

          <h5>
            Nom Espace : <strong>{selectedEntity.nom_espace}</strong>
          </h5>
          <h5>
            Numéro : <strong>{selectedEntity.numero}</strong>
          </h5>
          <h5>
            Type esapace :{" "}
            <strong>
              {selectedEntity.type_espace.split(".").pop().toLowerCase()}
            </strong>
          </h5>
          <h5>
            Date de création :{" "}
            <strong>
              {" "}
              {moment(selectedEntity.created_at).format("MMMM Do YYYY")}
            </strong>
          </h5>
           <h5>
            Surface habitable : <strong>{selectedEntity.surface_habitable}</strong>
          </h5>
          <h5>
            surface plancher : <strong>{selectedEntity.sdp}</strong>
          </h5>
         
        </div>
      </>
    );
  }
  if (selectedEntityType === "pièce") {
    return (
      <>
        <div className="p-6">
          <img
            src="/images/piece.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />

          <h5>
            Nom Pièce : <strong>{selectedEntity.nom_piece}</strong>
          </h5>

          <h5>
            Typologie pièce :{" "}
            <strong>
              {selectedEntity.typologie_piece.split(".").pop().toLowerCase()}
            </strong>
          </h5>
          <h5>
            Date de création :{" "}
            <strong>
              {" "}
              {moment(selectedEntity.created_at).format("MMMM Do YYYY")}
            </strong>
          </h5>
        </div>
      </>
    );
  }
  return null;
};
